<template>
  <div class="mb-1">
    <dropdown
      :class="['w-100']"
      variant="standard btn-change-status"
      title="Manejar Estatus"
      :items="
        statuses.map(x => ({
          label: x.description,
          click: () => setCurrentStatusTarget(x)
        }))
      "
      icon="fas fa-exchange"
    />
  </div>
</template>

<script>
import dropdown from "dropdown";

export default {
  name: "ChangeStatusDropdown",
  components: { dropdown },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    statuses: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {
    setCurrentStatusTarget(val) {
      this.$emit("update", val);
    }
  }
};
</script>

<style scoped>
::v-deep #dropdownMenuButton.btn-change-status {
  background-color: transparent !important;
  color: #2db782 !important;
}
</style>
